import { customInstance } from "@repo/api-client";

/**
 * The single bootstrap query behind the venue switcher + venue resolution (query key `["me"]`).
 *
 * Ports & adapters: it goes through `@repo/api-client`'s fetch mutator (bearer token + typed
 * `ApiError`, so a 401 drives the shell's revocation sign-out), NOT a raw `fetch`. The generated
 * Orval client is a stale M0 placeholder here; it is regenerated from the backend OpenAPI at serial
 * integration (`just gen`), at which point a generated `useListVenues` hook supersedes this thin
 * accessor. Venue *roles* are NOT read here — they come from the access-token claims (@repo/auth).
 */
export interface VenueSummary {
  id: string;
  slug: string;
  displayName: string;
  timeZone: string;
  defaultLanguage: string;
  lifecycle: string;
}

interface PageResponse<T> {
  items: T[];
  nextCursor: string | null;
}

/** The account's venues (tenant-scoped server-side via RLS, TN-5). One page covers M1 venue counts. */
export async function fetchVenues(signal?: AbortSignal): Promise<VenueSummary[]> {
  const page = await customInstance<PageResponse<VenueSummary>>("/api/v1/venues?limit=100", {
    method: "GET",
    signal,
  });
  return page.items;
}

export interface ActivateInviteBody {
  tenantId: string;
  token: string;
  password: string;
}

/** Public accept-invite activation (no bearer token — the invite token is the credential). */
export async function activateInvite(
  body: ActivateInviteBody,
): Promise<{ userId: string; status: string }> {
  return customInstance("/api/v1/staff/invites/activate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
